module.exports = __webpack_public_path__ + "static/media/slide-1.612e4d06.png";